import React from 'react';
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {GenericSideMenuImageBox} from "./boxes/link/generic/generic-side-menu-item-image.box";
import {Image} from "../../raw-components/image/image";
import {GenericSideMenuItemPreIconBox} from "./boxes/link/generic/generic-side-menu-item-pre-icon.box";
import {GenericSideMenuItemIconBox} from "./boxes/link/generic/generic-side-menu-item-icon.box";
import {GenericSideMenuItemLabelBox} from "./boxes/link/generic/generic-side-menu-item-label.box";
import {Link} from "../../raw-components/link/link";
import {GenericSideMenuItemBox} from "./boxes/link/generic/generic-side-menu-item.box";
import {MenuItemComponentProps} from "../../../services/menu-items-common/menu-item-component-props.interface";
import {get} from 'lodash';
import {SideMenuItemContainerComponent} from "./side-menu-item-container.component";

interface GenericSideMenuLinkComponentProps extends  MenuItemComponentProps {
    withArrow?: boolean
    className?: string;
}

@observer
export class GenericSideMenuItemComponent extends OrbitComponent<GenericSideMenuLinkComponentProps> {

    private _onClickHandler = async () => {
        await this.props.menuItem.execute();
    }

    private _renderIcon = () => {
        if(!this.props.menuItem.iconSource || !this.props.menuItem.icon) {
            return null;
        }

        if(this.props.menuItem.iconSource === "themeIcons") {
            const Icon = this.services.theme.currentTheme.icons[this.props.menuItem.icon];
            if(!Icon) {
                this.services.logger.error(`Menu item ${this.props.menuItem.key} has configured icon ${this.props.menuItem.icon} which does not exist in currentTheme.icons`)

                return null;
            }

            return (<Icon size={2} title={this.props.menuItem.iconAltText ?? '' } />);
        } else if(this.props.menuItem.iconSource === 'themeImages') {
            const imageURI = get(this.services.theme.currentTheme.images, this.props.menuItem.icon, '');
            if(!imageURI) {
                this.services.logger.error(`Menu item ${this.props.menuItem.key} has configured icon ${this.props.menuItem.icon} which does not exist in currentTheme.images`)
                return null;
            }
            return (<Image src={imageURI} alt={this.props.menuItem.iconAltText ?? '' }/>)
        } else {
            return (<Image src={this.props.menuItem.icon} alt={this.props.menuItem.iconAltText ?? '' }/>)
        }
    }


    private _renderMenuItemContent = () => {

        if(this.props.menuItem.imageOnlyRendering) {
            return (
                <GenericSideMenuImageBox>
                    {this._renderIcon()}
                </GenericSideMenuImageBox>
            );
        }

        return (<>
            <GenericSideMenuItemPreIconBox active={this.props.menuItem.isMatchToCurrentUrl}/>
            <GenericSideMenuItemIconBox active={this.props.menuItem.isMatchToCurrentUrl}>
                {this._renderIcon()}
            </GenericSideMenuItemIconBox>
            <GenericSideMenuItemLabelBox>
                { this.props.menuItem.text }
            </GenericSideMenuItemLabelBox>
            { this.props.withArrow ? <this.services.theme.currentTheme.icons.forwardIcon size={2} /> : null }
        </>);

    }



    render() {

        let href = this.props.menuItem.getLinkUrl() ?? "";
        if(href) {
            href = this.services.location.buildFullUri(href).toString();
        }

        return (
            <SideMenuItemContainerComponent className={this.props.className} onClick={this._onClickHandler}>
                <Link href={decodeURI(encodeURI(href))}>
                    <GenericSideMenuItemBox active={this.props.menuItem.isMatchToCurrentUrl}>
                        {this._renderMenuItemContent()}
                    </GenericSideMenuItemBox>
                </Link>
            </SideMenuItemContainerComponent>
        );
    }
}